import script from "./MallOrderDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallOrderDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./MallOrderDetailPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__